module.exports = __webpack_public_path__ + "img/hero-lg.b8cfc080.png";